module.exports = __webpack_public_path__ + "img/compliance.1f7d48c2.svg";